<template>
    <div>
        <v-row justify="center">
            <v-col class="py-1 myProfile-photo-container">
                <v-avatar size="200" color="primary">
                   
                    <img
                        v-if="values.photo_url != null"
                        :src="values.photo_url"
                        alt="profile photo"
                        class="myProfile-photo"
                        
                    >
                     <span v-else class="white--text text-h1">{{values.name[0]}}</span>
                </v-avatar>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col class="py-1 myProfile-photo-container">
                <p class="pb-0 mb-0 font-weight-bold body-1 text-center">{{values.name}}</p>
                <p class="pb-0 mb-3  body-2 text-center">En merca desde {{values.admissionYear}}</p>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="py-1">
                <textFieldForm
                    name="p1"
                    label="Número de colaborador"
                    :valueInput="values.employe_number"
                    
                    @valueChange="(v) => {values.employe_number = v.trim(); delete serverErrors.employe_number}"
                    :errorMessages="serverErrors.employe_number"
                    :readonly="true"
                ></textFieldForm>
            </v-col>
        </v-row>
        <!-- <v-row>
            <v-col class="py-1">
                <textFieldForm
                    name="p1"
                    label="Nombre completo"
                    :valueInput="values.name"
                    
                    @valueChange="(v) => {values.name = v.trim(); delete serverErrors.name}"
                    :errorMessages="serverErrors.name"
                    :readonly="true"
                ></textFieldForm>
            </v-col>
        </v-row> -->
        <v-row>
            <v-col class="py-1">
                <textFieldForm
                    name="p1"
                    label="Correo electrónico laboral"
                    :valueInput="values.business_email"
                    
                    @valueChange="(v) => {values.business_email = v.trim(); serverErrors.business_email; delete serverErrors.business_email}"
                    :errorMessages="serverErrors.business_email"
                    :readonly="true"
                ></textFieldForm>

               
            </v-col>
        </v-row>
        <v-row>
            <v-col class="py-1">
                <textFieldForm
                    name="p1"
                    label="Correo electrónico personal"
                    :valueInput="values.email"
                    @valueChange="(v) => {values.email = v.trim(); serverErrors.email; delete serverErrors.email}"
                    :errorMessages="serverErrors.email"
                    :readonly="true"
                ></textFieldForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-1">
                <textFieldForm
                name="p1"
                label="Profesión"
                :valueInput="values.profession"
                
                @valueChange="(v) => {values.profession = v.trim(); delete serverErrors.profession}"
                :errorMessages="serverErrors.profession"
                :readonly="true"
                ></textFieldForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-1" >
                <autocompleteOneForm
                    name="p1"
                    label="Lugar de nacimiento"
                    :valueInput="values.birthplace"
                    
                    :items="serverItems.nationalities"
                    @valueChange="(v) => {values.birthplace = v; delete serverErrors.birthplace}"
                    :errorMessages="serverErrors.birthplace"
                    :readonly="true"
                ></autocompleteOneForm>
            </v-col>

        </v-row>

        <v-row>

            <v-col class="py-1">
                <textFieldForm
                    name="p1"
                    label="Fecha de nacimiento"
                    :valueInput="values.birthdate"
                    
                    @valueChange="(v) => {values.birthdate = v; delete serverErrors.birthdate}"
                    :errorMessages="serverErrors.birthdate"
                    :readonly="true"
                ></textFieldForm>
            </v-col>
        </v-row>
        
        <v-row>
            <v-col class="py-1" >
                <textFieldForm
                    name="p1"
                    label="Género"
                    :valueInput="values.gender"
                    :readonly="true"
                    :items="serverItems.genders"
                    @valueChange="(v) => {values.gender = v; delete serverErrors.gender}"
                    :errorMessages="serverErrors.gender"
                ></textFieldForm>
            </v-col>

        </v-row>

        <v-row>

            <v-col class="py-1">
                <textFieldForm
                    name="p1"
                    label="Estado civil"
                    :valueInput="values.marital_status"
                    :readonly="true"
                    :items="serverItems.marital_statuses"
                    @valueChange="(v) => {values.marital_status = v; delete serverErrors.marital_status}"
                    :errorMessages="serverErrors.marital_status"
                ></textFieldForm>
            </v-col>
        </v-row>

        <v-row>

            <v-col class="py-1" >
                <textFieldForm
                    name="p1"
                    label="C.U.R.P."
                    :valueInput="values.curp"
                    :readonly="true"
                    @valueChange="(v) => {values.curp = v.trim(); delete serverErrors.curp}"
                    :errorMessages="serverErrors.curp"
                ></textFieldForm>
            </v-col>
        </v-row>
       
        <v-row>

            <v-col class="py-1">
                <textFieldForm
                    name="p1"
                    label="R.F.C."
                    :valueInput="values.rfc"
                    :readonly="true"
                    @valueChange="(v) => {values.rfc = v.trim(); delete serverErrors.rfc}"
                    :errorMessages="serverErrors.rfc"
                ></textFieldForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-1">
                <textFieldForm
                    name="p1"
                    label="FONACOT"
                    :valueInput="values.fonacot_number"
                    :readonly="true"
                    @valueChange="(v) => {values.fonacot_number = v.trim(); delete serverErrors.fonacot_number}"
                    :errorMessages="serverErrors.fonacot_number"
                ></textFieldForm>
            </v-col>

        </v-row>

        <v-row>
            <v-col class="py-1" >
                <textFieldForm
                    name="p1"
                    label="INFONAVIT"
                    :valueInput="values.infonavit_number"
                    :readonly="true"
                    @valueChange="(v) => {values.infonavit_number = v.trim(); delete serverErrors.infonavit_number}"
                    :errorMessages="serverErrors.infonavit_number"
                ></textFieldForm>
            </v-col>

        </v-row>

        <v-row>

            <v-col class="py-1" >
                <textFieldForm
                    name="p1"
                    label="N.S.S."
                    :valueInput="values.nss"
                    :readonly="true"
                    @valueChange="(v) => {values.nss = v.trim(); delete serverErrors.nss}"
                    :errorMessages="serverErrors.nss"
                ></textFieldForm>
            </v-col>
        </v-row>

        <v-row>

            <v-col class="py-1">
                <textFieldForm
                    name="p1"
                    label="Teléfono"
                    :valueInput="values.phone"
                    :readonly="true"
                    @valueChange="(v) => {values.phone = v.trim(); delete serverErrors.phone}"
                    :errorMessages="serverErrors.phone"
                ></textFieldForm>
            </v-col>
        </v-row>


        
        <v-row v-if="values.children.length > 0">
            <v-col class=" font-weight-black black--text mb-0 text-body-2">
                <span>Hijos</span>
            </v-col>
        </v-row>
        <v-expand-transition v-for="(itemOpt, indexChild) in values.children" :key="indexChild" appear >
            <v-row align="center">
                <v-col cols="12" class="p-0">
                    <v-row>
                        <v-col cols="6" class="pr-0 py-1">
                            <textFieldForm
                                name="p1"
                                label="Género"
                                :valueInput="itemOpt.gender"
                                :readonly="true"
                                :items="serverItems.genders"
                                @valueChange="(v) => {itemOpt.gender = v; delete serverErrors[`children.${indexChild}.option_list.${indexChild}.option`]}"
                                :errorMessages="serverErrors[`children.${indexChild}.option_list.${indexChild}.option`]"
                            ></textFieldForm>
                        </v-col>
                        <v-col cols="6" class="pr-0 py-1">
                            
                            <textFieldForm
                                name="p1"
                                label="Fecha de nacimiento"
                                :valueInput="itemOpt.birthdate"
                                :readonly="true"
                                @valueChange="(v) => {itemOpt.birthdate = v; delete serverErrors[`children.${indexChild}.option_list.${indexChild}.option`]}"
                                :errorMessages="serverErrors[`children.${indexChild}.option_list.${indexChild}.option`]"
                            ></textFieldForm>
                        </v-col>
                    </v-row>
                    
                
                </v-col>

                
            </v-row>
        </v-expand-transition>
 


    </div>
</template>

<script>
import LocationInformation from '../../../components/LocationInformation.vue';
/* eslint-disable */
export default {
    props: ['values', 'serverErrors'],
    components: {
      'location-information': LocationInformation,
    },
    data(){
        return {
           
            rules: {
				required: [
                    v => {
                        if(v == null || v == undefined)
                            return "Campo requerido";
                        try {
                            if(v.trim() == "")
                                return "Campo requerido";
                        } catch (error) {
                            console.log(error);
                        }
                        return true;
                    }
				],
                
                quantity: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]*?$"))
                            return 'Solo números válidos';
                        if(!v)
                            return 'El campo es requerido'
                        return true;
                    }
                ],
                age: [
                    v => {
                        // if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,2})?$"))
                        //     return 'Solo números válidos';
                        if(!v)
                            return 'El campo es requerido'
                        return true;
                    }
                ],
                email: [
                    //v => !!v || 'El campo es requerido'
                    v => {
                        if(!v)
                        return 'El campo es requerido';
                        if(v.length > 0) {
                            try {
                                if(v.trim() == "")
                                    return "Campo requerido";
                            } catch (error) {
                                console.log(error);
                            }
                            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                            return pattern.test(v) || 'Correo no válido';
                        }
                        return true
                    }
                ],
                business_email:[
                    v => {
                        if(v.length > 0) {
                            try {
                                if(v.trim() == "")
                                    return "Campo requerido";
                            } catch (error) {
                                console.log(error);
                            }
                            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                            return pattern.test(v) || 'Correo no válido';
                        }
                        return true
                    }
                ],

                phone: [
                    v => {
                        if(!v)
                            return 'El campo es requerido';
                        if(v!= null && !v.match("^[0-9]*$"))
                            return 'Solo números';
                        if(v.length != 10){
                            return 'Máximo 10 caracteres';
                        }
                        try {
                            if(v.trim() == "")
                                return "Campo requerido";
                        } catch (error) {
                            console.log(error);
                        }
                        return true;
                    }
                ],
                payee_family_phone:[
                    v => {
                    
                        if(v!= null && !v.match("^[0-9]*$"))
                            return 'Solo números';
                        if(v.length > 10){
                            return 'Máximo 10 caracteres';
                        }
                        try {
                            if(v.trim() == "")
                                return "Campo requerido";
                        } catch (error) {
                            console.log(error);
                        }
                        return true;
                    }
                ],

                emergency_number: [
                    v => {
                        if(!v)
                            return 'El campo es requerido';
                        if(v!= null && !v.match("^[0-9]*$"))
                            return 'Solo números';
                        if(v.length < 10){
                            return 'Máximo 10 caracteres';
                        }
                        try {
                            if(v.trim() == "")
                                return "Campo requerido";
                        } catch (error) {
                            console.log(error);
                        }
                        return true;
                    }
                ],
                fonacot_number:[
                    v => {
                    
                        // if(v!= null && !v.match("^[0-9]*$"))
                        // return 'Solo números';
                        if(v.length > 5){
                            try {
                                if(v.trim() == "")
                                    return "Campo requerido";
                            } catch (error) {
                                console.log(error);
                            }
                            return 'Máximo 5 caracteres';
                        }
                        return true;
                    }
                ],
                infonavit_number:[
                    v => {
                        
                        // if(v!= null && !v.match("^[0-9]*$"))
                        // return 'Solo números';
                        if(v.length > 10){
                            try {
                                if(v.trim() == "")
                                    return "Campo requerido";
                            } catch (error) {
                                console.log(error);
                            }
                            return 'Máximo 10 caracteres';
                        }
                        return true;
                    }
                ],
             
            },
            serverItems: {
                nationalities:[],
                genders: [
                    //Masculino, Femenino, No Binario, Otro
                    {text: "Masculino", value: "MASCULINO"},
                    {text: "Femenino", value: "FEMENINO"},
                    {text: "No Binario", value: "NO BINARIO"},
                    {text: "Otro", value: "OTRO"},
                ],
                marital_statuses:[
                    //Soltero, Casado, Unión Libre
                    {text: "Soltero", value: "SOLTERO"},
                    {text: "Casado", value: "CASADO"},
                    {text: "Unión Libre", value: "UNIÓN LIBRE"},
                ],
                blood_types:[
                    //A+, A-, B+, B-, AB+, AB-, O+, O-
                    {text: "A+", value: "A+"},
                    {text: "A-", value: "A-"},
                    {text: "B+", value: "B+"},
                    {text: "B-", value: "B-"},
                    {text: "AB+", value: "AB+"},
                    {text: "AB-", value: "AB-"},
                    {text: "O+", value: "O+"},
                    {text: "O-", value: "O-"},
                ],
                diseases:[
                    // {text: "Asma", value: "ASMA"},
                    // {text: "Diabetes", value: "DIABETES"},
                    // {text: "Otro", value: "OTRO"},
                    {text: "Diabetes mellitus", value: 'DIABETES MELLITUS'},
                    {text: "hipertensión arterial sistémica", value: 'HIPERTENSIÓN ARTERIAL SISTÉMICA'},
                    {text: "Enfermedad pulmonar", value: 'ENFERMEDAD PULMONAR'},
                    {text: "Asma", value: 'ASMA'},
                    {text: "Enfermedad cardiovascular", value: 'ENFERMEDAD CARDIOVASCULAR'},
                    {text: "Enfermedad cerebrovascular" , value: 'ENFERMEDAD CEREBROVASCULAR'},
                    {text: "Enfermedad renal Crónica", value: 'ENFERMEDAD RENAL CRÓNICA'},
                    {text: "Enfermedad reumatológica", value: 'ENFERMEDAD REUMATOLÓGICA'},
                    {text: "VIH", value: 'VIH'},
                    {text: "Otros", value: 'OTROS'},
                ],
            },

          

          
        }
    },
    mounted(){
        this.getCountries();
    },
    methods: {
       
        /**
            Get countries from api
        */
        getCountries()
        {
            this.$locationsApi.locations.getCountries()
            .then((resp) => {
                this.serverItems.nationalities = resp.data;
                //console.log(resp.data);
            
                
            });
        },
    
    }
}
</script>

<style lang="scss">
    .myProfile{
        &-photo-container{
            text-align: center;
            position: relative;
        }

        &-photo{

            width: auto;
            // height: 200px;
            text-align: center;
            object-position: 20% 0%;
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;

        }
    }

    .image-cropped-transform {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: 55%;
        transform: scale(0.5) translate(0, 5%);
    }
</style>